import { DataService } from './data.service';
function _window() {
    return window;
}
var NotificationService = (function () {
    function NotificationService(_data) {
        this._data = _data;
    }
    Object.defineProperty(NotificationService.prototype, "nativeWindow", {
        get: function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    NotificationService.prototype.getPermissions = function () {
        this.notification = this.nativeWindow.Notification || this.nativeWindow.mozNotification || this.nativeWindow.webkitNotification;
        if (typeof this.notification !== 'undefined' || !this.hasPermission) {
            this.notification.requestPermission(function (permission) { });
            return true;
        }
    };
    NotificationService.prototype.notify = function (title, content, file) {
        if (file === void 0) { file = "logo_notification.png"; }
        var self = this;
        var notificar = new Notification(title, {
            body: content,
            dir: 'auto',
            lang: self._data.configuration["language"],
            tag: 'notificationPopup',
            icon: 'assets/img/' + file
        });
    };
    NotificationService.prototype.hasPermission = function () {
        switch (this.notification.permission) {
            case "granted":
                return true;
            case "denied":
                return false;
            default:
                return false;
        }
    };
    return NotificationService;
}());
export { NotificationService };
